/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleLockRequest } from '../../models/article-lock-request';
import { ArticleLockResult } from '../../models/article-lock-result';
import { KeyType } from '../../models/key-type';

export interface PutCheckinArticleLock$Params {
  organizationSiteKey: KeyType;
  checkinKey: string;
  articleKey: KeyType;
      body: ArticleLockRequest
}

export function putCheckinArticleLock(http: HttpClient, rootUrl: string, params: PutCheckinArticleLock$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleLockResult>> {
  const rb = new RequestBuilder(rootUrl, putCheckinArticleLock.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('checkinKey', params.checkinKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleLockResult>;
    })
  );
}

putCheckinArticleLock.PATH = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/article-locks/{articleKey}';
